import React from 'react'

interface IContext {
  previewPlayer: HTMLDivElement | null,
  previewPlayerBox: React.MutableRefObject<HTMLDivElement | null>,
  onSetPreviewPlayer: React.RefCallback<HTMLDivElement>,
  imageSource: HTMLImageElement | undefined,
  canvasSource: HTMLCanvasElement | undefined,
  videoSource: HTMLVideoElement | undefined,
  setImageSource(object: HTMLImageElement | undefined): void,
  setCanvasSource(object: HTMLCanvasElement | undefined): void,
  setVideoSource(object: HTMLVideoElement | undefined): void,
  handleFullscreen(): void,
  captureFrame(isMedia: boolean): void,
}

export const PreviewPlayerContext = React.createContext<IContext>({} as IContext)
